import type { IVocalise } from './vocalise';
import { vocaliseSchema } from './vocalise';
import { actionCreator, Joi, objectSchemaOf } from '../helpers';

export const DISPLAY = 'VOCALISE/DISPLAY';

export interface IDisplayAction {
  type: typeof DISPLAY;
  payload: IVocalise;
}

export const displayActionSchema = objectSchemaOf<IDisplayAction>({
  type: Joi.string().required().valid(DISPLAY),
  payload: vocaliseSchema.required(),
});

export const display = actionCreator({
  type: DISPLAY,
  schema: displayActionSchema,
});
